import React from 'react';
import {
  createTheme,
  Switch as MuiSwitch,
  ThemeProvider,
  useTheme,
} from '@mui/material';

export default function Switch({ checked, onChange }: any) {
  const { palette }: any = useTheme();

  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          colorPrimary: {
            '&.Mui-checked': {
              // Controls checked color for the thumb
              color: palette.primary.main,
            },
          },
          switchBase: {
            // Controls default (unchecked) color for the thumb
            color: '#fff',
          },
          track: {
            // Controls default (unchecked) color for the track
            '.Mui-checked.Mui-checked + &': {
              // Controls checked color for the track
              backgroundColor: '#B0CDFF',
              opacity: 1,
            },
            backgroundColor: '#78879F',
            opacity: 1,
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <MuiSwitch checked={checked} onChange={onChange} size="small" />
    </ThemeProvider>
  );
}
